'use strict';

import {addCustomEventListener, setTransformStyle, addClass, removeClass, hasClass} from './helpers';

export const cursor = (() => {
  const _curSor = document.getElementById('curSor');
  const curSorW = _curSor.clientWidth;
  const curSorH = _curSor.clientHeight;
  const _curInn = document.getElementById('curInn');
  let cX = 0;
  let cY = 0;

  const setCurPosition = (e) => {
    cX = e.pageX - curSorW * 0.75;
    cY = e.pageY - curSorH * 0.575;
    setTransformStyle(_curSor, `translate3d(${cX}px,${cY}px,0)`);
  }

  const togglePlayerCur = (event = 'hide') => {
    if (event === 'hide' && hasClass(_curSor, 'player')) {
      addClass(_curSor, 'hide');
    } else {
      removeClass(_curSor, 'hide');
    }
  }

  const eventListeners = () => {
    window.addEventListener('mouseover', e => {
      const _this = e.target.closest('[data-cursor]') || e.target.dataset.cursor;

      if (_this) {
        if (!hasClass(_curSor, 'active')) {
          setCurPosition(e);
          addClass(_curSor, 'active');
        }

        if (_this.dataset.cursorType === 'text') {
          addClass(_curSor, 'text');
          _curInn.innerHTML = `<div id="curTxt" class="crsr__txt">${_this.dataset.cursorContent}</div>` || '';
        } else if (_this.dataset.cursorType === 'player') {
          addClass(_curSor, 'player');
          _curInn.innerHTML = `<div class="crsr__plr"><div class="crsr__plr__play"></div></div>`;
        }
      } else {
        if (hasClass(_curSor, 'active')) {
          removeClass(_curSor, 'active text player');
          _curInn.innerHTML = '';
        }
      }
    });
    window.addEventListener('mousemove', e => {
      const _this = e.target.closest('[data-cursor]') || e.target.dataset.cursor;
      if (_this) {
        setCurPosition(e);
      }
    });
  };

  const init = () => {
    if (!_curSor) {
      return false;
    }
    eventListeners();
    window.shApp.cursor = {
      togglePlayerCur: togglePlayerCur,
    }
  };

  return {
    init
  }
})();
